import React, { useState , useCallback, useEffect} from "react";
import FilterInput from "components/Form/filterInput"
import { Tag } from 'antd';
import { toTitleCase } from "utils/common";
import { useSearchParams } from 'react-router-dom';
import { Button } from "components/Button";


const SalaryListFilter = ({handleFilterDrawer, filters, handleInputChange, searchPlaceholder, handleFilterChange, loading}) => {


const [searchParams, setSearchParams] = useSearchParams();

  const [appliedFilters, setAppliedFilters] = useState([])


  const setInputValue = useCallback((key) => {
   console.log(filters, "---filters in setinputvalueeeeeee")
    if(filters.length){
      let selectedValue = [...filters].find(item=> item.key === key)
      return selectedValue?.value
    }else{
      return ""
    }  
  }, [filters]);

    useEffect(()=>{
      console.log('salary list filter--->>', ...filters )   

      let _appliedFilters = [...filters].map(item=>{
        let label = ""
        let value = ""
        switch(item.key){         
            case "search":
              value = toTitleCase(searchParams.get("search") || "")
              label = "Search term"
              break;            
          case "user":
            let user = []
            let selectedUser = [...user].find(item=>item.id == searchParams.get("user") || "")           
            value = selectedUser?.name
            break;
       
            case "email":       
             label = "Email"
              value = searchParams.get("email") || ""
            break;
          default:
            label = ""
            value = ""
        }
        return {
          ...item,
          value,
          label
        }
      })
      setAppliedFilters(_appliedFilters.filter(item=> item.value && item.key != "search"))

  
 

 
  },[
  
    searchParams
  ])


  const handleClose = (e, item) => {
    console.log(item, "llll")
    e.preventDefault();
    if(item.key == "search"  ){
      handleInputChange("", item.key, true)
    }else{
      handleFilterChange("", item.key, true)
    }
  }
  return (
    <div>
      <div className="row filter-row mb-4">
        <div className="col-10 ">
          
        <div className="row" >
        <div className='col-sm-12 col-lg-4' >
        <FilterInput  
         defaultValue={setInputValue("search")} 
         onChange={e=>{handleInputChange(e.target.value, "search", true)}} 
          id="search"
           label={searchPlaceholder}
            />
        </div>
        <div className='col-sm-12  col-lg-8  mt-1 flex-wrap' >
          
        {
            appliedFilters.map(item=>{
              return (
                <Tag icon={loading&&<i class="fas fa-spinner fa-spin me-1" aria-hidden="true"></i>} className="mb-1" color={"red"} closable closeIcon={<i class="fa fa-times" aria-hidden="true"></i>} onClose={e=>handleClose(e, item)}>
                  {
                    item?.label
                  }
                  {item.label && " : "}
                  {item?.value}
                </Tag>
              )
            })
          }

        </div>
        </div>


      
        </div>
      
 
        <div className="col-2 d-flex justify-content-end" style={{ paddingRight: 0 }}>
        <div className="view-icons">
          <Button onClick={handleFilterDrawer} icon="las la-filter" 
          // id="collapse-header"
           className="list-view btn btn-link "/>
        </div>
       
        </div>
      </div>
    </div>
  );
};

export default SalaryListFilter;
